import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import BeforeAfter from '../components/BeforeAfter';
import CommittedExcellence from '../components/CommittedExcellence';
import About from '../components/About';
import TransformNaturally from '../components/TransformNaturally';
import ClinicHighlights from '../components/ClinicHighlights';
import FreeConsultation from '../components/FreeConsultation';
import JourneyReels from '../components/JourneyReels';
import Testimonials from '../components/Testimonials';
import BlogPosts from '../components/BlogPosts';
import ContactForm from '../components/ContactForm';
import Locations from '../components/Locations';
import Footer from '../components/Footer';
import SideContact from '../components/SideContact';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0B3D2E] text-[#ffffff] font-sans-body">
      <Header />
      <Hero />
      <BeforeAfter />
      <About />
      <CommittedExcellence />
      <TransformNaturally />
      <ClinicHighlights />
      <FreeConsultation />
      <JourneyReels />
      <Testimonials />
      <BlogPosts />
      <ContactForm />
      <Locations />
      <Footer />
      <SideContact />
    </div>
  );
};

export default Home;
